<template>

<div class="faq">

  <div class="container" >
                
    <div class="row">

      <div class="col-md-6 col-sm-6 col-xs-9 justify-content-center m-auto textcontent">
      
            <div class="accordion" id="accordionExample">
              <div class="card" v-for="(faq,fi) in $parent.lang.faq" v-bind:key="fi">
                <div class="card-header" id="headingOne">
                  <h5 class="mb-0">
                    <button class="btn btn-link bigbutton text-left faqbutton" :ref="'menucol'+fi" type="button" @click="open(fi)" >
                      {{faq.title}}
                    </button>

                  </h5>
                </div>

                <div :id="'collapse'+fi" class="collapse" :ref="'collapse'+fi" >
                  <div class="card-body" v-html="faq.description">

                  </div>
                </div>
              </div>
            </div>

      </div>

    </div>

  </div>

</div>
</template>
<script>




export default {
  name: 'Faq',
  components: {
  },
  data(){ return {

    
    }
  },
  created: function () {


  },
  updated: function(){

  },
  computed:{



  },
  
  methods:{
    open: function(fi){
      var s = document.getElementsByClassName("show");
      var o = document.getElementsByClassName("open");
      var i;

        if (this.$refs['collapse'+fi][0].classList.contains('show')) {
          this.$refs['collapse'+fi][0].classList.remove('show');
        } else {
          for (i = 0; i < s.length; i++) {
            s[i].classList.remove('show');
          }
          this.$refs['collapse'+fi][0].classList.add('show');
        }

        if (this.$refs['menucol'+fi][0].classList.contains('open')) {
          this.$refs['menucol'+fi][0].classList.remove('open');
        } else {
          for (i = 0; i < o.length; i++) {
            o[i].classList.remove('open');
          }
          this.$refs['menucol'+fi][0].classList.add('open');
        }

    }

    

  }
  
}
</script>